// Order ticket reasons come from the `elakayTicket` language catalogue
// (MongoDB FrTxtLanguage, falling back to the bundled menuElakay_*.json --
// see language/mergeLanguageSources.js). It is a flat array: four parent
// groups at fixed positions, each listing its leaf reasons' _ids in
// `subTicket`. The leaf _ids are the stable identities the Auto Suspend
// Ticket rules (AnimationSettings.automaticTicketSuspension.ticketRules[]
// .ticketId) are keyed by, so OrdersView and AutomaticTicketSuspensionPanel
// must both read the groups through this module.
export const TICKET_GROUP_INDEX = Object.freeze({
  returnDetail: 0,
  returnAction: 1,
  cancelDetail: 2,
  cancelAction: 3,
});

// Reason group (and its Auto Suspend Ticket category) for each ticket status
// a buyer can file from Orders. Must match ticketCategoryForStatus in
// server_elakay/elakay_services/autoSuspensionTrigger.js.
export const REASON_GROUP_BY_STATUS = Object.freeze({
  Cancelled: 'cancelDetail',
  'Return or replace': 'returnDetail',
});

// subTicket entries are plain id strings in the bundled JSON but
// { subTicket: ObjectId } subdocuments in the MongoDB schema.
const entryId = (entry) => String(entry?.subTicket ?? entry?._id ?? entry ?? '');

export const ticketGroup = (elakayTicket, groupName) => {
  if (!Array.isArray(elakayTicket)) return null;
  const parent = elakayTicket[TICKET_GROUP_INDEX[groupName]];
  return parent && Array.isArray(parent.subTicket) ? parent : null;
};

export const childrenOf = (elakayTicket, parent) => {
  if (!parent || !Array.isArray(elakayTicket) || !Array.isArray(parent.subTicket)) return [];
  const ids = new Set(parent.subTicket.map(entryId));
  return elakayTicket.filter((item) => item && String(item._id) !== String(parent._id) && ids.has(String(item._id)));
};

export const reasonGroupForStatus = (elakayTicket, status) => {
  const groupName = REASON_GROUP_BY_STATUS[status];
  return groupName ? ticketGroup(elakayTicket, groupName) : null;
};

export const reasonsForStatus = (elakayTicket, status) =>
  childrenOf(elakayTicket, reasonGroupForStatus(elakayTicket, status));
